import { render, staticRenderFns } from "./custom-breadcrumb.vue?vue&type=template&id=9ef63a04"
import script from "./custom-breadcrumb.vue?vue&type=script&lang=js"
export * from "./custom-breadcrumb.vue?vue&type=script&lang=js"
import style0 from "./custom-breadcrumb.vue?vue&type=style&index=0&id=9ef63a04&prod&lang=css"


/* normalize component */
import normalizer from "!./node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports